import Vue from 'vue'
import Vuex from 'vuex'
import decode from 'jwt-decode'
import router from '../router'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    token:null,
    usuario:null,
    rol:null
  },
  mutations: {
    setToken(state,token){
      state.token = token
    },
    setUsuario(state,usuario){
      state.usuario = usuario
    }
  },
  actions: {
    guardarToken({commit},token){
      commit("setToken",token)
      commit("setUsuario",decode(token))
      localStorage.setItem("token",token)
    },
    autoLogin({commit}){
      let token = localStorage.getItem("token")

      if(token)
      {
        commit("setToken",token)
        commit("setUsuario",decode(token))
      }
      
      if(this.state.usuario.rol == 'Cliente' || this.state.usuario.rol == 'Subusuario'){
        router.push({name:'Tracking'})
      }else{
        router.push({name:'calendario'})
      }

    },

    salir({commit}){

      commit("setToken",null,null)
      commit("setUsuario",null,null)
      localStorage.removeItem("token")
      router.push({name:'login'})

    }

  },
  modules: {
  }
})
